import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

// Components
import Videos from "./Videos";

// Context
import { TagsContext } from "../../context/tags";
import { VideosContext } from "../../context/videos";

const VideosContainer = (props) => {
    const { showConfirmationModal } = props;

    /**
     * Router Hooks
     */

    const history = useHistory();

    /**
     * useContext
     */

    const { clearTags, selectedTags, tags } = useContext(TagsContext);
    const {
        filteredVideos,
        handleSelectPage,
        isFiltering,
        isSearchActive,
        isSearching,
        shouldShowFilteredVideos,
        totalPages,
        totalVideos,
        videos,
        videoSearchResults,
    } = useContext(VideosContext);

    /**
     * useState
     */

    const [videosCollection, setVideosCollection] = useState([]);
    const [shouldShowConfirmationModal, setShouldShowConfirmationModal] =
        useState(showConfirmationModal);

    /**
     * useEffect
     */

    useEffect(() => {
        return () => clearTags();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isSearchActive && !shouldShowFilteredVideos) {
            setVideosCollection(videos);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSearchActive]);

    useEffect(() => {
        if (shouldShowFilteredVideos) {
            setVideosCollection(filteredVideos);
        } else {
            setVideosCollection(videos);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filteredVideos, shouldShowFilteredVideos]);

    useEffect(() => {
        if (videos && !isSearchActive && !shouldShowFilteredVideos) {
            setVideosCollection(videos);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videos]);

    useEffect(() => {
        if (isSearchActive && !shouldShowFilteredVideos) {
            setVideosCollection(videoSearchResults);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videoSearchResults]);

    /**
     * Constants
     */

    const hasSelectedTags = !!selectedTags?.length;

    /**
     * End Hooks
     */

    function handleSelect(video) {
        history.push({ pathname: `/videos/${video.id}`, state: { video } });
    }

    function toggleConfirmationModal(bool) {
        setShouldShowConfirmationModal((prev) => bool || !prev);
    }

    return (
        <Videos
            {...props}
            handleSelect={handleSelect}
            handleSelectPage={handleSelectPage}
            hasSelectedTags={hasSelectedTags}
            isFiltering={isFiltering}
            isSearchActive={isSearchActive}
            isSearching={isSearching}
            selectedTags={selectedTags}
            shouldShowConfirmationModal={shouldShowConfirmationModal}
            tags={tags}
            toggleConfirmationModal={toggleConfirmationModal}
            totalPages={totalPages}
            totalVideos={totalVideos}
            videosCollection={videosCollection}
            videoSearchResults={videoSearchResults}
        />
    );
};

export default VideosContainer;
